import {Breadcrumb, Col, Pagination, Row} from 'antd';
import axios from 'axios';
import {useEffect, useState} from 'react';
import {useDevice} from '../hooks/useDevice';
import Footer from '../component/Footer';
import CardItem from '../component/CardItem';

export default function Topic() {
    const {isMobile} = useDevice();
    const [dataTopic, setdataTopic] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 12,
    });

    const topic = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/topic/getAll`, {params: pagination});
            console.log(response.data)
            setdataTopic(response?.data);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }

    useEffect(() => {
        topic();
    }, []);

    return (
        <>
            <div className="max-w-screen-xl items-center mx-auto p-4 h-screen">
                <Breadcrumb
                    className="py-5"
                    items={[
                        {
                            title: <a href="/">Home</a>,
                        },
                        {
                            title: <a href="/topic">Topic</a>,
                        }
                    ]}
                />
                <p className="text-4xl text-center py-10">Tất cả chương trình học</p>
                {loading ? (
                    <div className="py-20"><div className="max-w-screen-xl mx-auto"><div className="flex justify-center"><div className="animate-spin rounded-full border-4 border-t-transparent border-blue-500 h-10 w-10"></div></div></div></div>
                ) : (
                    <Row className='pt-[30px]' gutter={[16, 16]}>
                        {dataTopic?.data?.map((topic, index) => (
                            <Col xs={24} sm={12} md={8} xl={6} key={index} className='mt-2'>
                                <CardItem
                                    to={'/course/' + topic.slug}
                                    title={topic.title}
                                    subtitle={topic.description}
                                    meta={`${topic.totalCourses || 0} courses`}
                                    image={topic.image_url}
                                    imageAlt={topic.title}
                                />
                            </Col>
                        ))}
                    </Row>
                )}
                <Pagination
                    className="flex justify-center pt-[50px]"
                    current={pagination.page}
                    total={topic?.total}
                    pageSize={pagination.pageSize}
                    onChange={(p, ps) => {
                        setPagination({
                            page: p,
                            pageSize: ps
                        })
                    }}
                />
            </div>
            {Footer()}
        </>
    );
};
